import { render, staticRenderFns } from "./Cago.vue?vue&type=template&id=4a5e233c&scoped=true"
import script from "./Cago.vue?vue&type=script&lang=js"
export * from "./Cago.vue?vue&type=script&lang=js"
import style0 from "./Cago.vue?vue&type=style&index=0&id=4a5e233c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e233c",
  null
  
)

export default component.exports